var $ = require("jquery");
var round = require("lodash/round");

module.exports = {
    update: function() {
        var $el = $(".currency");

        if (!$el.length) {
            return;
        }

        $.get("//24smi.info/api/currency").then(function(data) {
            var data = JSON.parse(data);
            $el.append("<li>" + round(data.usd.current, 2) + " &#8381;</li>");
            $el.append("<li>" + round(data.eur.current, 2) + " &#8381;</li>");
        });
    }
};
